import { Reveal, Eyebrow } from "@/lib/motion";

export default function Problem() {
  return (
    <section id="problem" className="relative bg-bg-primary/55 py-24 backdrop-blur-sm lg:py-32">
      <div className="container-max band-pad">
        <Reveal>
          <Eyebrow testId="problem-eyebrow">The drag you can’t see</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-4xl font-display text-3xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-[52px] lg:leading-[1.08]">
            You didn’t hire an ops team to run a{" "}
            <span className="text-ink-muted">group chat.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-ink-muted">
            Every handoff turns into a Slack thread. Every SLA risk gets caught
            after it’s already blown. Every “who owns this?” costs twenty minutes
            and a context switch. None of that shows up on a dashboard —{" "}
            <span className="font-medium text-signal">until now.</span>
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-hairline bg-hairline sm:grid-cols-3">
          {[
            { k: "20 min", v: "lost per “who owns this?”" },
            { k: "after", v: "when SLA risk usually surfaces" },
            { k: "0", v: "of it visible on today’s dashboard" },
          ].map((s, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08} className="bg-bg-surface">
              <div className="p-7">
                <div className="font-mono text-3xl font-medium text-warning">
                  {s.k}
                </div>
                <div className="mt-2 text-sm text-ink-muted">{s.v}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
